<!-- 头部 -->
<template>
  <div class="student-activity-logo">
    <img src="@/assets/images/common/logo.svg" alt="美国手机卡" @click="goTOEnc('/')" />
    <div class="right">
      <span @click="goTOEnc('/activation/first')">激活手机卡</span>
      <span @click="goTOEnc('/login')">登录</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    goTOEnc(url) {
      let origin = location.origin;
      window.open(origin + url, '_self');
    }
  }
};
</script>
<style scoped lang="less">
@media (min-width: 768px) {
  .student-activity-logo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 60px;
    padding: 0 100px;

    img {
      width: 200.276px;
      height: 48px;
      cursor: pointer;
    }

    > div {
      span {
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #696969;
        cursor: pointer;

        &:first-child {
          margin-right: 40px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .student-activity-logo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 10.6667vw;
    padding: 0 5.3333vw;

    img {
      width: 26.6453vw;
      height: 6.4vw;
      cursor: pointer;
    }
    .right {
      span {
        &:nth-of-type(1) {
          margin-right: 1.3333vw;
        }
      }
    }
  }
}
</style>
